import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Logs = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Logs</Text>
      <Text>Bienvenido a tus Logs</Text>
    </Box>
  );
};

export default Logs;
